import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
      setSearchTerm('');
    }
  };

  return (
    <header className="site-header">
      <div className="logo">
        <Link to="/">每日一果</Link>
      </div>
      <nav className="main-nav">
        <NavLink to="/" end>首页</NavLink>
        <NavLink to="/categories/efficacy">按功效</NavLink>
        <NavLink to="/categories/season">按季节</NavLink>
      </nav>
      <form className="search-bar" onSubmit={handleSearch}>
        <input
          type="text"
          placeholder="搜索水果、功效..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button type="submit">搜索</button>
      </form>
    </header>
  );
};

export default Header;
